export function docusignDocURL(docusignDomain: string, docusignId: string) {
    return `${docusignDomain}/send/documents/details/${docusignId}`
}